
import base from '../base'; // 导入接口域名列表
import axios from '@/utils/http'; // 导入http中创建的axios实例

const mainpageApi = {
    getMainPageConfig: function () {
        const params = {
            "apiname": "mainpagenew",
            "methodname": "getMainPageConfig"
        };
        let res = axios.post(`${base.businessBase}`, params);
        return res;
    },
    addToCart(pk, source) {
        const params = {
            "apiname": "mainpagenew",
            "methodname": "addToCart",
            "pk": pk,
            "source": source
        };
        return axios.post(`${base.businessBase}`, params);
    },
    getCartNum() {
        const params = {
            "apiname": "mainpagenew",
            "methodname": "getCartNum"
        };
        return axios.post(`${base.businessBase}`, params);
    },
    loadJdProducts(rank) {
        const params = {
            "apiname": "mainpagenew",
            "methodname": "loadJdProducts",
            "rank": rank
        };
        return axios.post(`${base.businessBase}`, params);
    },
    loadMalSwiper(rank) {
        const params = {
            "apiname": "mainpagenew",
            "methodname": "loadMalSwiper",
            "rank": rank
        };
        return axios.post(`${base.businessBase}`, params);
    },
    loadBottombox(rank) {
        const params = {
            "apiname": "mainpagenew",
            "methodname": "loadBottombox",
            "rank": rank
        };
        return axios.post(`${base.businessBase}`, params);
    },
    loadStoreBody(rank) {
        const params = {
            "apiname": "mainpagenew",
            "methodname": "loadStoreBody",
            "rank": rank
        };
        return axios.post(`${base.businessBase}`, params);
    },
    loadCardBody(rank) {
        const params = {
            "apiname": "mainpagenew",
            "methodname": "loadCardBody",
            "rank": rank
        };
        return axios.post(`${base.businessBase}`, params);
    },
    getNavJo(source) {
        const params = {
            "apiname": "mainpagenew",
            "methodname": "getNavJo",
            "source": source
        }
        return axios.post(`${base.businessBase}`, params);
    },

};
export default mainpageApi;